import { put, call, takeLatest, takeEvery, fork, all, select } from "redux-saga/effects";
import { getThriveCard, getThriveReport, getThriveReportV2, getWellBeingReport, getReportPdf } from "../api/thriveApi";
import * as types from "../constants/actionTypes";
import { log, logAPI } from "../api/andyliticsApi";
import * as Tools from "../helpers/Tools";

export default function* thriveSaga() {
    yield takeLatest(types.THRIVE_GET_CARD, handleGetThriveCard);
    yield takeLatest(types.THRIVE_GET_REPORT, handleGetThriveReport);
    yield takeLatest(types.GET_WELLBEING_REPORT, handleGetWellBeingReport);
    yield takeLatest(types.GET_WELLNESS_REPORT_PDF, handleGetReportPdf);
}

export function* handleGetThriveCard(payload) {
    const start = new Date();
    const isEmployee = yield select((state) => state.domain.ie);
    try {
        if (isEmployee) {
            yield put({ type: types.THRIVE_GET_CARD_PENDING });
            const card = yield call(getThriveCard, payload.token);
            if (card.error && card.error.length > 0) {
                let error = card.error;
                yield put({ type: types.THRIVE_GET_CARD_FAILURE, error });
                logAPI("MBHWeb.Saga.Thrive.Card.Get.Failure", start, null, error);
            }
            else {
                yield put({ type: types.THRIVE_GET_CARD_SUCCESS, card });
                if (card) {
                    let andyliticThriveCardRes = {
                        surveyStatus: card.surveyStatus ? card.surveyStatus : null,
                        surveyUrl: card.surveyUrl ? card.surveyUrl : null
                    };
                    logAPI("MBHWeb.Saga.Thrive.Card.Get", start, null, andyliticThriveCardRes);
                } else {
                    logAPI("MBHWeb.Saga.Thrive.Card.Get", start, null);
                }
            }
        }
    }
    catch (error) {
        yield all([
            put({ type: types.THRIVE_GET_CARD_FAILURE, error }),
            put({ type: types.AJAX_CALL_ERROR })
        ]);
        logAPI("MBHWeb.Saga.Thrive.Card.Get.Failure", start, null, error);
    }

}

export function* handleGetThriveReport(payload) {
    const start = new Date();
    const defaultReportYear = start.getFullYear();
    let report = {};

    try {
        yield put({ type: types.THRIVE_GET_REPORT_PENDING });
        if (payload && payload.reportYear) {
            const reportYear = payload && payload.reportYear ? payload.reportYear : defaultReportYear;
            report = yield call(getThriveReportV2, payload.token, reportYear);
        }
        else {
            report = yield call(getThriveReport, payload.token);
        }

        if (report.error && report.error.length > 0) {
            let error = report.error;
            yield put({ type: types.THRIVE_GET_REPORT_FAILURE, error });
            logAPI("MBHWeb.Saga.Thrive.Report.Get.Failure", start, null, error);
        }
        else {
            yield put({ type: types.THRIVE_GET_REPORT_SUCCESS, report });
            logAPI("MBHWeb.Saga.Thrive.Report.Get", start, null);
        }
    }
    catch (error) {
        yield all([
            put({ type: types.THRIVE_GET_REPORT_FAILURE, error }),
            put({ type: types.AJAX_CALL_ERROR })
        ]);
        logAPI("MBHWeb.Saga.Thrive.Report.Get.Failure", start, null, error);
    }
}
export function* handleGetWellBeingReport(payload) {
    const start = new Date();
    const defaultReportYear = start.getFullYear();
    let report = {};

    try {
        yield put({ type: types.GET_WELLBEING_REPORT_PENDING });
        const reportYear = payload && payload.reportYear ? payload.reportYear : defaultReportYear;
        report = yield call(getWellBeingReport, payload.token, reportYear);
        if (report.error && report.error.length > 0) {
            let error = report.error;
            yield put({ type: types.GET_WELLBEING_REPORT_FAILURE, error });
            logAPI("MBHWeb.Saga.Thrive.WellBeingReport.Get.Failure", start, null, error);
        }
        else {
            yield put({ type: types.GET_WELLBEING_REPORT_SUCCESS, report });
            logAPI("MBHWeb.Saga.Thrive.WellBeingReport.Get.Success", start, null);
        }
    }
    catch (error) {
        yield all([
            put({ type: types.GET_WELLBEING_REPORT_FAILURE, error }),
            put({ type: types.AJAX_CALL_ERROR })
        ]);
        logAPI("MBHWeb.Saga.Thrive.WellBeingReport.Get.Failure", start, null, error);
    }
}

export function* handleGetReportPdf(payload) {
    const start = new Date();
    const defaultReportYear = start.getFullYear();
    const reportYear = payload && payload.reportYear ? payload.reportYear : defaultReportYear;

    try {
        const response = yield call(getReportPdf, payload.token, reportYear);
        logAPI("MBHWeb.Saga.Thrive.ReportPdf.Get", start, null);
    }

    catch (error) {
        logAPI("MBHWeb.Saga.Thrive.ReportPdf.Get", start, null, error);
    }
}
